export const leaveBalanceEnums = {
  leaveBalance: "Leave Balance",
  leaveCategory: "Leave Category",
  remainingLeave: "Remaining Leaves",
  leaveCount: "Added Leave",
  totalLeave: "Total Leave",
  balanceLeave: "Balance Leaves",
  reset: "Reset",
  unpaidLeave: "Unpaid leave",
  addedBy: "Added By",
  updatedOn: "Updated On",
  previousCount: "Remaining Leave",
  finalCount: "Total Leave",
  leaveBalanceHistory: "Leave Balance History",
  SrNo: "Sr No.",
  extraWorkingDeleteConfirmation: "Are you sure you want to delete this extra working day?",
  extraWorkingDay: "Extra Working Day",
  delete: "Delete",
};
